import { formatToLocaleString } from "Formatting/formatNumber";

export const formatNumberVariableWithUnicode = (
  value: number,
  isNegativeNumber = false,
): string => {
  const getNegativeNumberPrefix = isNegativeNumber ? "\u2212" : "";

  return `${getNegativeNumberPrefix}${formatToLocaleString(
    Math.round(value),
  )}${"\u2009"}`;
};
